module.exports = __webpack_public_path__ + "static/media/norton.f4551804.png";